<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rnENW/images/cover.jpg?1684514318358" alt="This image is the cover for the book Preaching Hebrews"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Preaching Hebrews
      </h1>
      <p class="bookDescription body article font2">
        <p>The Rochester College Sermon Seminar and the series of books it has inspired have been built on the conviction that Christian preaching today needs revision. Such reforming begins with a close and faithful reading of Scripture, an engagement so serious that the world of Scripture ultimately sets agendas and invents expectations for meaningful life...In this present volume, too, we wish to grant the book of Hebrews the opportunity to pull all of us into the world it envisions, allowing it the power to judge, convict, and form us into a community God desires. This is not an easy task for several reasons, most notably the fact that the world of Hebrews is quite alien from our own...Like previous volumes in the Rochester Lectures on Preaching, the current work is divided into two parts. The first is a collection of four related essays meant to orient the reader to the world clearly conceived in Hebrews. The second half appropriates this orientation with sermons for particular Christian congregations.<br/><br/>- <i>Excerpts from David Fleer's Introduction</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Fleer, Dave Bland
      </h2>
      
      <p class="authorDescription body article">David Fleer's devotion to preaching first found expression through a long-tenured pulpit ministry with the Vancouver Church of Christ in the state of Washington. His Ph.D. in Speech Communication at the University of Washington moved him into teaching, where he is currently Professor of Religion and Communication at Rochester College. Co-editor of the current series on preaching, David's work is characterized as a thoughtful and passionate attempt to walk afresh in the world of Scripture so that readers and listeners may experience the reality of the Gospel of God.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ACU Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4dc748a0